/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
/* eslint import/prefer-default-export: "off" */
import React, { Component } from 'react';

import { connect } from 'react-redux'
import { compose } from 'redux'

import {
  firebaseConnect,
  // getFirebase,
//   isLoaded,
  // isEmpty
} from 'react-redux-firebase'
import { contextA } from '../../redux/store/configureStore';


const mapStateToPropsWrapper = (state /* , ownProps */) => {
  const { firebase, context } = state;
  return ({
    auth: firebase.auth,
    profile: firebase.profile,
    context,
    partners: firebase.data && firebase.data.partners,
  })
}


// const firebaseConfigWrapper = (props, firebase) => {
const firebaseConfigWrapper = (props) => {
  const { match = {} } = props
  const { partner } = match.params || {}
  // console.log('firebaseConfigWrapper');
  return (
    [
      { path: '/partners/', queryParams: ['orderByChild=url', `equalTo=${partner}`, 'limitToFirst=1'] },
    ]
  )
}
// eslint-disable-next-line react/prefer-stateless-function
const Wrapper = (MainComponent, ...rest) => class WrappedComp extends Component {
  render() {
    const extraProps = (rest && rest[0]) || {}
    const partner = this.props.partners ?
      this.props.partners[Object.keys(this.props.partners)[0]] : null
    return partner ? (
      <MainComponent
        {...this.props}
        {...extraProps}
        partner={partner}
      />
    ) : <h1>Waiting...for {this.props.match.params.partner}</h1>
  }
}

const withAppContext = (MainComponent, ...rest) => compose(
  firebaseConnect(firebaseConfigWrapper),
  connect(mapStateToPropsWrapper, null, null, {
    context: contextA,
  }),
)(Wrapper(MainComponent, ...rest))

export { withAppContext }




// WEBPACK FOOTER //
// ./src/lib/context/index.js